import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { map } from 'lodash';

@Pipe({
    name: 'safeDate',
    pure: false
})
export class SafeDatePipe extends DatePipe {
    
    transform(value: any, pattern?: string): string | null {
        if (typeof value === 'string') {
            value = value.replace(' ', 'T');
        }
        return super.transform(value, pattern);
    }

}


// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/pipes/safe-date.pipe.ts